"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorMtaExcessChangeBanner = void 0;
var React = require("react");
var AnnualMotorMtaExcessChangeBanner = /** @class */ (function (_super) {
    __extends(AnnualMotorMtaExcessChangeBanner, _super);
    function AnnualMotorMtaExcessChangeBanner(props) {
        return _super.call(this, props) || this;
    }
    AnnualMotorMtaExcessChangeBanner.prototype.render = function () {
        var compulsoryExcess = this.props.interaction.vehicles[0].annualVehicleExcess.compulsoryExcess;
        var voluntaryExcess = this.props.interaction.vehicles[0].annualVehicleExcess.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        return (React.createElement("div", { className: "panel font-weight-extra-light mb-4" },
            React.createElement("div", { className: "ml-1 mb-1 banner banner-info additional-warning margin-top-0 margin-bottom-0" },
                React.createElement("p", null,
                    "Heads up - as a result of this change your compulsory excess may change. Your total excess will be ",
                    React.createElement("strong", null,
                        "\u00A3",
                        totalExcess)))));
    };
    return AnnualMotorMtaExcessChangeBanner;
}(React.Component));
exports.AnnualMotorMtaExcessChangeBanner = AnnualMotorMtaExcessChangeBanner;
//# sourceMappingURL=AnnualMotorMtaExcessChangeBanner.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/annual/motor/AnnualMotorMtaExcessChangeBanner.js
// module id = 3204
// module chunks = 0